export type { TabListProps, TabPanelProps, TabProps, TabsProps } from '../../types/tabs';
export { Tab } from './adapters/inbound/Tab';
export { TabList } from './adapters/inbound/TabList';
export { TabPanel } from './adapters/inbound/TabPanel';
export { Tabs } from './adapters/inbound/Tabs';
